import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/HighlightOffOutlined';
import { AdminTestContext } from '@orientaction/Context';
import { FC, useContext, useMemo } from 'react';
import VariableForm from '../VariableForm';
import style from './style';

const VariableDrawer = () => {
  const { test, updateTest } = useContext<any>(AdminTestContext);
  const classes = style();

  const idAglomeration = useMemo(() => {
    return test.idAglomerationSelected;
  }, [test.idAglomerationSelected]);

  const handleClose = () => {
    updateTest({ variableAglomerationDrawerOpen: false, variableAglomerationToEdit: null });
  };

  return (
    <Drawer
      anchor="right"
      open={test.variableAglomerationDrawerOpen}
      classes={{ root: classes.rootStyle, paper: classes.drawerContent }}>
      <div className={classes.headerContainer}>
        <IconButton className={classes.closeBtn} onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
        <div className={classes.titleContainer}>
          <Typography variant="h3" className={classes.title}>
            {`${test.variableAglomerationToEdit ? 'Modifier' : 'Ajouter'} une restitution`}
          </Typography>
        </div>
      </div>
      <div className={classes.contentChild}>
        <VariableForm idAglomeration={idAglomeration} />
      </div>
    </Drawer>
  );
};

export default VariableDrawer;
